// extracted by mini-css-extract-plugin
export default {"resetButton":"_n_ODZf","root":"ZzwcEVD"};